import ExplanationCard from "./ExplanationCard";
import ChartIcon from "@/assets/icons/graph.svg?react";
import MarkdownRenderer from "@/components/UI/MarkdownRenderer";
import type { PlotAgentSource } from "./chat";

type ChatPlotCardProps = {
  sources: PlotAgentSource[];
  chatExplanation?: boolean;
};

export default function ChatPlotCard({
  sources,
  chatExplanation = true,
}: ChatPlotCardProps) {
  return (
    <div>
      {sources.map((s, index) => {
        return (
          <div key={s.citation?.source_url ?? index}>
            <ExplanationCard
              title="Plot Agent"
              chatExplanation={chatExplanation}
              Icon={ChartIcon}
            >
              <div className="flex flex-col gap-4 text-[#556C75] markdown">
                <MarkdownRenderer content={s.response} />
                <div>
                  <strong>Plot Configuration: </strong>
                  <MarkdownRenderer content={s.explanation ?? ""} />
                </div>
              </div>
            </ExplanationCard>
          </div>
        );
      })}
    </div>
  );
}
